import { FC } from 'react';
import Checkbox from 'antd/lib/checkbox/Checkbox';
import Item from 'antd/lib/form/FormItem';
import InputNumber from 'antd/lib/input-number';

import { formRules, questionMarks } from 'utils/constants/constants';
import { EPoliciesFields } from 'types/settings/enums';

export const discountInputNumberProps = { maxLength: 2, min: 20, max: 50, className: 'w-16', placeholder: '20' };

const TradingPoliciesGeneral: FC = () => (
  <>
    <h4 className="mb-4">General</h4>
    <Item
      shouldUpdate
      tooltip={{ title: questionMarks.account.discount }}
      label="What discount do you offer on your products to AutoDS members?"
      rules={[formRules.required]}
      labelCol={{ span: 24 }}
      wrapperCol={{ span: 12 }}
    >
      {({ getFieldValue }) => (
        <div className="flex items-center gap-2.5">
          <Item name={EPoliciesFields.Discount} noStyle rules={[formRules.required]}>
            <InputNumber
              size="large"
              disabled={getFieldValue(EPoliciesFields.HasDiscount)}
              {...discountInputNumberProps}
            />
          </Item>
          <Item name={EPoliciesFields.HasDiscount} noStyle valuePropName="checked">
            <Checkbox>I’m already offering wholesale prices on my site</Checkbox>
          </Item>
        </div>)}
    </Item>
  </>
);

export default TradingPoliciesGeneral;
